<!--
 * @Description: 敏感词申诉
 * @Author: Lxc 1533761120@qq.com
 * @Date: 2024-07-11 10:59:52
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-07-11 15:36:50
-->
<script setup lang="ts">
import { useRiskWordAppealStore } from '@/store/modules/risk-word-appeal'
import { appealSensitiveWord } from '@/api'

const route = useRoute()
const riskWordAppealStore = useRiskWordAppealStore()

function onClose() {
  riskWordAppealStore.updateRiskWordAppealModal(false)
}

function onConfirm() {
  console.log('module', route)
  appealSensitiveWord({ module: route.meta.posthogTitle as string, riskWords: riskWordAppealStore.riskWordsList }).then(() => {
    window.$message?.success('申诉成功')
    riskWordAppealStore.updateRiskWordAppealModal(false)
  }).catch((error) => {
    window.$message?.error(error.resultMsg)
  })
}
</script>

<template>
  <NModal v-model:show="riskWordAppealStore.isShowRiskWordAppealModal" :mask-closable="false" :close-on-esc="false">
    <div class="risk-word-appeal-modal">
      <div class="header">
        <div class="title">敏感词申诉</div>
        <div class="close" @click="onClose">
          <div class="icon"></div>
        </div>
      </div>
      <div class="content">
        检测到您的文字包含敏感信息。涉及敏感词汇：{{ riskWordAppealStore.riskWordsList.join(',') }}。若有误判，请点击申诉。我们将在24小时内处理。
      </div>
      <div class="footer">
        <NSpace justify="end" :size="12">
          <button class="footer-btn cancel-btn" @click="onClose">取消</button>
          <button class="footer-btn button-gradient" @click="onConfirm">申诉</button>
        </NSpace>
      </div>
    </div>
  </NModal>
</template>

<style lang="scss" scoped>
.risk-word-appeal-modal {
  width: 500px;
  background-color: #fff;
  border-radius: 8px;

  .header {
    padding: 24px;
    position: relative;

    .title {
      font-size: 16px;
      color: #242F57;
      font-weight: 500;
    }

    .close {
      position: absolute;
      top: 16px;
      right: 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .icon {
        width: 20px;
        height: 20px;
        background: url('./close.png') no-repeat;
        background-size: contain;
      }
    }
  }

  .content {
    padding: 0 24px 24px;
    max-height: 500px;
    overflow-y: auto;
  }

  .footer {
    padding: 0 24px 24px;

    .footer-btn {
      width: 92px;
      height: 32px;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      overflow: hidden;
    }

    .cancel-btn {
      border: 1px solid #C4C8CC;
      &:hover {
        border-color: #4050FF;
      }
    }
  }
}
</style>